import { Box, Paper } from '@material-ui/core';

export const Wiki = () => {
  return (
    <Paper>
      <Box minHeight={800}>
        <iframe
          title="wiki"
          style={{ border: 'none', width: '100%', height: '800px' }}
          src="https://api.sneg.chernogolovka.com/service/wiki/"
        />
      </Box>
    </Paper>
  );
};
